import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { PrimeNgModule } from "../prime-ng/prime-ng.module";
import { PipeModule } from "../shared/Pipe/pipe.module";
import { LoginRoutingModule } from "./login-routing.module";
import { LoginComponent } from "./login.component";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";

@NgModule({
  declarations: [LoginComponent],
  imports: [
    CommonModule,
    PrimeNgModule,
    FormsModule,
    PipeModule,
    LoginRoutingModule,
    TranslateModule,
  ],
  exports: [],
})
export class LoginModule {}
